// extracted by mini-css-extract-plugin
module.exports = {"linksPaddingTop":"34","mediaQueryTablet":"(min-width: 768px)"};